export default "__VITE_ASSET__CronDZ5x__"